import { Checkbox, FormControlLabel, makeStyles, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';


const operators = [
    { value: "gt", label: "GT", types: ["number", "date", "datatable", "length"] },
    { value: "ge", label: "GE", types: ["number", "date", "datatable", "length"] },
    { value: "eq", label: "EQ", types: ["string", "number", "date", "datatable", "boolean", "length"] },
    { value: "ne", label: "NE", types: ["string", "number", "date", "datatable", "boolean", "length"] },
    { value: "empty", label: "EMPTY", types: ["string"] },
    { value: "nempty", label: "NEMPTY", types: ["string"] },

    { value: "hop", label: "HOP", types: ["object"] },

    { value: "contains", label: "CONTAINS", types: ["string", "array"] },
    { value: "dncontains", label: "DNCONTAINS", types: ["string", "array"] },

    { value: "sw", label: "SW", types: ["string"] },
    { value: "ew", label: "EW", types: ["string"] },
    { value: "dnsw", label: "DNSW", types: ["string"] },
    { value: "dnew", label: "DNEW", types: ["string"] },
    { value: "lt", label: "LT", types: ["number", "date", "datatable", "length"] },
    { value: "le", label: "LE", types: ["number", "date", "datatable", "length"] },



    { value: "weekly", label: "WEEKLY", types: ["date_time"] },
    { value: "monthly", label: "MONTHLY", types: ["date_time"] },
    { value: "yearly", label: "YEARLY", types: ["date_time"] },
    { value: "custom", label: "CUSTOM", types: ["date_time"] }
];

const useStyles = makeStyles(theme => ({
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    },
    inputRoot: {
        "& fieldset": {
            borderColor: '#E6E6E6',
            borderWidth: '1.1px'
        }
    },
    popupIndicator: {
        color: "#B0B0B0",
        height: "10px",
        width: "10px"
    }
}));

const WidgetCondition = ({ filter, filters, label, completeData, setCompleteData, selectedReport, index }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const conditionLabel = 'CONTENT.CONFIGURATION-FORM.CONDITION.';

    const changeOperator = (v) => {
        // setManipulations(prev => {
        //     let m = [...prev];

        //     m[index].conditions[conditionIndex].operator = v ? v.value : '';
        //     return m;
        // });

        setCompleteData(pre => {
            const newFilter = JSON.parse(JSON.stringify(pre))
            newFilter.customFilters[index].operator = v
            return newFilter
            return { ...pre, customFilters: [...filters, { ...filter, operator: v }] }
        });
    }

    const handleAddFilter = () => {
        setCompleteData((pre) => {
            const newFilter = JSON.parse(JSON.stringify(pre))
            newFilter.customFilters.push({ column: null, operator: null, value: "", mandatory: false })
            return newFilter
        })
    }

    const handleRemoveFilter = () => {
        setCompleteData((pre) => {
            let newFilter = JSON.parse(JSON.stringify(pre))
            if (newFilter.customFilters.length > 1) {
                newFilter.customFilters = newFilter.customFilters.filter((item, i) => i !== index);
            }
            else {
                newFilter.customFilters = [{ column: null, operator: null, value: "", mandatory: false }]
            }
            return newFilter
        })
    }


    return (
        <div className='db-widget-filter-item-container'>
            <div className='db-widget-add-filter-container'>
                <Autocomplete
                    // className='db-filter-autocomplete'
                    className='custimize-text-area db-operator-input'
                    // key={filter.type || ''}
                    value={filter.column}
                    onChange={(event, newValue) => {
                        setCompleteData(pre => {
                            const newFilter = JSON.parse(JSON.stringify(pre))
                            newFilter.customFilters[index].column = newValue
                            newFilter.customFilters[index].operator = null
                            return newFilter
                        });
                    }}
                    size="small"
                    options={selectedReport.filter_columns}
                    getOptionLabel={(option) => {
                        return t(label + option.label)
                    }}
                    // renderInput={(params) => <TextField {...params} label="Select column" variant="outlined" />}
                    classes={{
                        option: classes.option,
                        inputRoot: classes.inputRoot,
                        popupIndicator: classes.popupIndicator
                    }}
                    renderInput={(params) => (

                        <TextField
                            {...params}
                            id='operator-list-text'
                            className="select-action-input"
                            placeholder="Select Column"
                            variant="outlined"
                            classes={{
                                root: classes.inputRoot
                            }}
                            inputProps={{
                                ...params.inputProps,
                                "aria-autocomplete": 'new-password',
                                autoComplete: 'new-password', // disable autocomplete and autofill
                                style: {
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: '#46474E'
                                }
                            }}
                        />

                    )}
                // isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
                <div className='db-add-filter-button db-add-button' onClick={handleAddFilter}><span>+</span></div>
                <div className='db-add-filter-button db-remove-button' onClick={handleRemoveFilter}><span>-</span></div>
            </div>

            {
                filter.column?.type &&
                <Autocomplete
                    key={`operator_${index}`}// key={filter.operator || ''}
                    value={filter.operator}
                    onChange={(e, newValue) => changeOperator(newValue)}
                    id={`data-transform-condition-operator-${index}`}
                    className='custimize-text-area db-operator-input'
                    size="small"
                    options={operators.filter(x => {
                        return x.types.includes(filter?.column?.type)
                    })}
                    classes={{
                        option: classes.option,
                        inputRoot: classes.inputRoot,
                        popupIndicator: classes.popupIndicator
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option?.label ? t(conditionLabel + option.label) : ""}
                    renderOption={(option) => (
                        t(conditionLabel + option.label)
                    )}
                    renderInput={(params) => (

                        <TextField
                            {...params}
                            id='operator-list-text'
                            className="select-action-input"
                            placeholder="Select Operator"
                            variant="outlined"
                            classes={{
                                root: classes.inputRoot
                            }}
                            inputProps={{
                                ...params.inputProps,
                                "aria-autocomplete": 'new-password',
                                autoComplete: 'new-password', // disable autocomplete and autofill
                                style: {
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: '#46474E'
                                }
                            }}
                        />

                    )}
                />
            }
            {/* <TextField value={filter.conditionValue} className='db-filter-autocomplete' label="Type value" variant="outlined" onChange={(e, value) => {
                setCompleteData(pre => {
                    const newFilter = JSON.parse(JSON.stringify(pre))
                    newFilter.customFilters[index].conditionValue = value
                    return newFilter
                });
            }} /> */}
            {
                filter.operator?.value && filter.operator.value !== 'empty' &&
                filter.operator.value !== 'nempty' && filter.column?.type !== 'date_time' &&

                <TextField
                    key={`target_${index}`}
                    id="filled-size-small"
                    value={filter.value}
                    onChange={(e) => {
                        setCompleteData(pre => {
                            const newFilter = JSON.parse(JSON.stringify(pre))
                            newFilter.customFilters[index].value = e.target.value;
                            return newFilter
                        });
                    }}
                    className='db-filter-autocomplete'
                    variant="outlined"
                    size="small"
                    inputProps={{ style: { fontSize: 12 } }}
                />
            }
            {
                filter.operator?.value &&
                filter.operator.value === 'custom' && filter.column?.type === 'date_time' &&
                <div className='db-filter-custom-date-container'>
                    <TextField value={filter.custom_date?.start_date}
                        type={"date"}
                        onChange={(e) => {
                            setCompleteData(pre => {
                                const newFilter = JSON.parse(JSON.stringify(pre))
                                newFilter.customFilters[index] = { ...newFilter.customFilters[index], custom_date: { ...newFilter.customFilters[index].custom_date, start_date: e.target.value } };
                                return newFilter
                            });
                        }}
                        label="Select Start Date"
                        className='db-filter-autocomplete'
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField value={filter.custom_date?.end_date}
                        type={"date"}
                        onChange={(e) => {
                            setCompleteData(pre => {
                                const newFilter = JSON.parse(JSON.stringify(pre))
                                newFilter.customFilters[index] = { ...newFilter.customFilters[index], custom_date: { ...newFilter.customFilters[index].custom_date, end_date: e.target.value } };
                                return newFilter
                            });
                        }}
                        label="Select End Date"
                        className='db-filter-autocomplete'
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </div>
            }
            {filter.column?.type &&
                <FormControlLabel
                    className='disable-end-date-checkbox'
                    control={
                        <Checkbox
                            className='db-mandatory-checkbox'
                            checked={filter.mandatory}
                            onChange={(e) => {
                                setCompleteData(pre => {
                                    const newFilter = JSON.parse(JSON.stringify(pre))
                                    newFilter.customFilters[index].mandatory = e.target.checked;
                                    return newFilter
                                });
                            }}
                            name="disableEndDate"
                            color="#C4C4C4"
                            size="small"
                        />
                    }
                    label={t(label + 'MANDATORY-CONDITION')} />
            }
        </div>

    )
}

export default WidgetCondition